import { Modal,SpinLoading, DotLoading  } from "antd-mobile";
import titleImages from "../../images/index/title.png";
import styles from "./index.module.scss";
export interface ModalProps {
  title: string
  content: string | React.ReactNode | JSX.Element
  confirmText: string
  cancelText?: string
  onConfirm?: () => void
}
export const showLoading = (text?: string,displayType = 'block') => {
  return <div className={styles.loading_view}>
    <img  src={titleImages} className={styles.loading_img}  alt="" />
      <SpinLoading className={styles.loading} color="#00B676" style={{ '--size': '50px' }} />
      <div className={styles.text}>
     {/*  <p>{text? text: null}</p> */}
      </div>
  </div>
}
export const modalAlert = async (props: ModalProps) => {
  const { title, content,confirmText,onConfirm } = props;
  return await Modal.alert({
    title,
    header:(
      <img style={{width:'118px', height: '29.5px'}} src={titleImages} alt="" />
    ),
    content,
    confirmText:(
    confirmText
    ),
    onConfirm: onConfirm
  })
}
export const modalConfirm = async (props: ModalProps) => {
  const { title, content,confirmText,cancelText } = props;
  return await Modal.confirm({
    title,
    header:(
      <img style={{width:'118px', height: '29.5px'}} src={titleImages} alt="" />
    ),
    content,
    confirmText:(
      confirmText
    ),
    cancelText:(
      cancelText
    ),
  })
}
